import classNames from 'classnames';
import { useIntl } from 'react-intl';
import type { ActiveQuoteDashboard } from 'state/workspaces/workspaces/workspaces.model';

interface DashboardProps {
  e2e: string;
  isActive: ActiveQuoteDashboard;
  onShow: () => void;
  onHide: () => void;
  isDisabled: boolean;
}

export function DashboardTab({ e2e, isActive, isDisabled, onShow, onHide }: DashboardProps): React.JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <button
      data-e2e={e2e}
      className={classNames('btn btn-lg btn-icon btn-flat-secondary', {
        active: isActive === 'show',
      })}
      onClick={isActive === 'show' ? onHide : onShow}
      disabled={isDisabled}
      title={formatMessage({ id: 'dashboard.tab.title' })}
    >
      <i className="icon icon-md">grid_view</i>
    </button>
  );
}
